import jsC8 from "jsc8";
import { streamAppNames } from "../../util/constants";
import config from "./serviceConfig";

const jsc8Client = new jsC8({
    url: config.gdnURL,
    apiKey: config.apiKey,
});

export const createStreamReader = async (streamName, filters) => {
    let response;
    try {
        response = await jsc8Client.createStreamReader(
            streamName,
            `${streamName}-${Math.round(Math.random() * 1000)}`,
            false,
            false,
            config.gdnURL.replace("https://", ""),
            { filters }
        );
    } catch (error) {
        console.error(error);
    }
    return response;
};

export const publishStreamApp = async () => {
    try {
        for (const element of streamAppNames) {
            await fetch(`${config.streamAppsApiEndpoint}${element}/active?active=true`, {
                method: "PATCH",
                headers: {
                    Authorization: `apikey ${config.apiKey}`,
                },
            });
        }
        return true;
    } catch (error) {
        console.error(error);
        return false;
    }
};

export const unpublishStreamApp = async () => {
    try {
        for (const element of streamAppNames) {
            await fetch(`${config.streamAppsApiEndpoint}${element}/active?active=false`, {
                method: "PATCH",
                headers: {
                    Authorization: `apikey ${config.apiKey}`,
                },
            });
        }
        return true;
    } catch (error) {
        console.error(error);
        return false;
    }
};
